export default __webpack_public_path__ + "static/media/no-data.6cc812fc.svg";